import {
  Application,
  Organisation,
  Program,
  Tour,
  User,
} from '@univacity/shared/types';

export class AnalyticsUtil {
  static user(user: User) {
    return {
      name: `${user.firstName || ''} ${user.middleName || ''} ${
        user.lastName || ''
      }`.trim(),
      first_name: user.firstName,
      last_name: user.lastName,
      middle_name: user.middleName,
      email: user.email,
      username: user.username,
      organisation: user.organisation,
      gender: user.gender,
      role: user.role,
      type: user.type,
    };
  }

  static application(app: Application) {
    return {
      id: app._id,
      intake: app.intake,
      organisation: app.organisation,
      program: app.program,
      creator: app.creator,
      agency: app.agency,
      contact: app.contact,
      campus: app.campus,
      commission: app.commission,
      status: app.status,
      submittedAt: app.submittedAt,
      createdAt: app.createdAt,
      updateAt: app.updatedAt,
    };
  }
  static program(p: Program) {
    const { extra, ...cost } = p.cost || {};
    return {
      id: p._id,
      name: p.name,
      organisation: p.organisation,
      status: p.status,
      level: p.level,
      cover: p.cover,
      format: p.format,
      attendance: p.attendance,
      creator: p.creator,
      cost,
    };
  }
  static tour(p: Tour) {
    return {
      id: p._id,
      name: p.name,
      organisation: p.organisation,
      status: p.status,
      coverPhoto: p.coverPhoto,
      theme: p.theme,
      country: p.address?.country,
      languages: p.languages,
      currency: p.currency,
      pricing: p.pricing,
      sales: p.sales,
      creator: p.creator,

      createdAt: p.createdAt,
      updateAt: p.updatedAt,
    };
  }

  static organisation(o: Organisation): Record<string, any> {
    return {
      id: o._id,
      name: o.name,
      logo: o.logo,
      category: o.category,
      type: o.type,
      slug: o.slug,
      isPartner: o.isPartner,
      address: o.address,
      cover: o.cover,
      country: o.address?.country,
      currency: o.currency,
      founded: o.founded,
      createdAt: o.createdAt,
      updateAt: o.updatedAt,
      creator: o.creator,
    };
  }
}
